import { Col, Form, Select } from "antd";
import CustomDatePicker from "common/CustomDatePicker";
import { useEffect, useState } from "react";
import { DIGITALIZATION_OFFLINE_APP_MODULES } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
const FailedItemsFilterFields = ({ initialTableData }) => {
  const { Option } = Select;
  const [salseCotractList, setSalseCotractList] = useState([]);

  useEffect(() => {
    getSalseCotractList();
  }, []);

  const getSalseCotractList = async () => {
    let res = await getData(DIGITALIZATION_OFFLINE_APP_MODULES);

    if (res) {
      setSalseCotractList(Object.keys(res?.data?.data) || []);
    }
  };
  return (
    <>
      <Col span={4}>
        <Form.Item label="Sync Date" name="sync_date">
          <CustomDatePicker placeholder="Select a date" size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="App Modules" name="module_name">
          <Select
            showSearch
            placeholder="Select an app module"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            size="small"
          >
            {salseCotractList?.length &&
              salseCotractList.map((sup) => (
                <Option value={sup} key={sup}>
                  {sup}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default FailedItemsFilterFields;
